import { emitTopicEvent } from "@client/nanostores/eventBus"
import { map } from "nanostores"

export type SearchParams = {
  page: number
  limit: number
  stateCode: string
}

export const $searchProvidersWebsiteSearchParams = map<SearchParams>({
  page: 1,
  limit: 10,
  stateCode: "",
})

export const updateSearchProvidersWebsiteSearchParams = (
  partial: Partial<SearchParams>,
) => {
  $searchProvidersWebsiteSearchParams.set({
    ...$searchProvidersWebsiteSearchParams.get(),
    ...partial,
  })
}

export const getWebsiteProviders = () => {
  emitTopicEvent(
    "website-providers:load",
    $searchProvidersWebsiteSearchParams.get(),
  )
}
